<template>
  <v-data-table :headers="visibleHeaders" :items="locations" :items-per-page-options="CONST.ROWS_PER_PAGE_ITEMS">
    <template v-if="canUpdate || canDelete" #[`item.actions`]="{ item }">
      <div class="action-cell">
        <v-btn v-if="canUpdate" icon size="small" variant="text" class="table-action-button" aria-label="Editar" @click="editItem(getRawItem(item))">
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn v-if="canDelete" icon size="small" variant="text" class="table-action-button table-action-danger" aria-label="Eliminar" @click="deleteItem(getRawItem(item))">
          <v-icon>delete</v-icon>
        </v-btn>
      </div>
    </template>
    <template #[`item.types`]="{ item }">
      <div class="d-flex flex-wrap ga-1 justify-center">
        <v-chip v-for="type in item.types" :key="type.id" size="small" variant="tonal">{{ type.name }}</v-chip>
        <span v-if="!item.types?.length" class="text-medium-emphasis">Sin tipo</span>
      </div>
    </template>
    <template #no-data>
      <span>{{ CONST.NO_RESULTS_CHECK_FILTERS }}</span>
      <v-btn color="primary" class="ml-3" @click="initialize">{{ CONST.REFRESH }}</v-btn>
    </template>
  </v-data-table>
</template>
<script>
import CONST from '../../services/common/Constants.js'
import { mapGetters } from 'vuex'
export default {
  name: 'Location',
  data: () => ({
    CONST: {},
    itemType: 'UBICACION',
    headers: [
      {title: 'Nombre', align: 'center', key: 'name'},
      {title: 'Tipos', align: 'center', key: 'types', sortable: false},
      {title: 'Direccion', align: 'center', key: 'address'},
      {title: 'Ciudad', align: 'center', key: 'city'},
      {title: 'Provincia', align: 'center', key: 'province'},
      {title: 'Pais', align: 'center', key: 'country'},
      {title: 'Codigo Postal', align: 'center', key: 'postalCode'},
      {title: 'Acciones', align: 'center', key: 'actions', sortable: false}
    ],
    locations: []
  }),

  computed: {
    ...mapGetters(['isRefreshTableRequired']),
    ...mapGetters('authModule', ['hasPermission']),
    canUpdate () { return this.hasPermission('catalog.locations.update') },
    canDelete () { return this.hasPermission('catalog.locations.delete') },
    visibleHeaders () {
      return this.canUpdate || this.canDelete ? this.headers : this.headers.filter(header => header.key !== 'actions')
    },
    ...mapGetters('locationModule', ['getFilteredLocations'])
  },

  created () {
    this.CONST = CONST
    this.initialize()
  },

  watch: {
    getFilteredLocations: function () {
      this.locations = this.$store.getters['locationModule/getFilteredLocations']
    },
    isRefreshTableRequired: function (newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.initialize()
      }
    }
  },

  methods: {
    initialize () {
      this.$store.dispatch('locationModule/getLocations').then(() => {
        this.locations = this.$store.getters['locationModule/getLocations']
      })
    },

    getRawItem (item) {
      return item.raw || item
    },

    editItem (item) {
      this.$store.dispatch('locationModule/setDialogActived', true)
      this.$store.dispatch('locationModule/setSelectedItem', item)
    },

    deleteItem (item) {
      confirm(`Estas seguro de querer eliminar: ${item.name}?`) && this.$store.dispatch('locationModule/removeLocation', item.id).then(() => {
        this.initialize()
      }).catch(error => console.log('There was an error trying to delete Location.' + error))
    }
  }
}
</script>
